import React from "react";
import {useSelector} from "react-redux";
import {
  DetailsHeader,
  DetailsListLayoutMode,
  type IDetailsHeaderProps,
  type IRenderFunction,
} from "@fluentui/react";

import styles from "./CalculationNoteFoundationLoadCases.module.scss";
import type {RootState} from "../../../../store";
import type CalculationNoteFoundationLoadCase from "../../../../types/CalculationNoteFoundationLoadCase";
import IsaacTable from "../../../../components/isaacTable/IsaacTable";
import useFoundationResultsTableColumns from "../../hooks/useFoundationResultsTableColumns";

const CalculationNoteFoundationLoadCases: React.FC<{mastNo: string}> = ({
  mastNo,
}) => {
  const {foundationResults} = useSelector(
    (state: RootState) => state.constructionCalculationsNote,
  );
  const {primaryHeaders, secondaryHeaders} = useFoundationResultsTableColumns();

  const handleRenderHeader: IRenderFunction<IDetailsHeaderProps> = props => {
    return (
      <>
        <div role="row" className={styles.mainHeadersGroup}>
          {primaryHeaders.map(header => (
            <div
              key={header.key}
              className={styles.mainHeader}
              style={{
                flex: header.colSpan,
              }}>
              {header.name}
            </div>
          ))}
        </div>

        <DetailsHeader
          {...props}
          className={styles.secondaryHeadersGroup}
          layoutMode={DetailsListLayoutMode.justified}
        />
      </>
    );
  };

  return (
    <div className={styles.container}>
      {foundationResults && (
        <IsaacTable<CalculationNoteFoundationLoadCase>
          key={mastNo}
          items={foundationResults[mastNo]}
          columns={secondaryHeaders}
          onRenderHeader={handleRenderHeader}
          className={styles.table}
        />
      )}
    </div>
  );
};

export default CalculationNoteFoundationLoadCases;
